<ion-header>
  <ion-toolbar>
    <ion-title>Pago con tarjeta</ion-title>
    <ion-buttons slot="start">
      <ion-back-button
        defaultHref="/tecservice-transportec/wallet/balance/payment-method"
        color="primary"
      ></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>Datos de tarjeta</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-item>
          <ion-label position="stacked">Nombre completo*</ion-label>
          <ion-input type="text" placeholder="Ej. Manuel López Hernández" formControlName="fullname"></ion-input>
        </ion-item>
        <p
          *ngIf="form.controls['fullname'].errors && (form.controls['fullname'].dirty || form.controls['fullname'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">Número de tarjeta*</ion-label>
          <ion-input
            id="cc"
            #cc
            formControlName="creditCard"
            placeholder="1234 5678 9012 3456"
            type="tel"
            autocomplete="cc-number"
            ccNumber
            (ionChange)="ccTypeCheck($event)"
          ></ion-input>
          <ion-icon src="/assets/icon/mastercard.svg" slot="end" *ngIf="ccType == 'mastercard'"></ion-icon>
          <ion-icon src="/assets/icon/visa.svg" slot="end" *ngIf="ccType == 'visa'"></ion-icon>
          <ion-icon src="/assets/icon/amex.svg" slot="end" *ngIf="ccType == 'amex'"></ion-icon>
        </ion-item>
        <p
          *ngIf="form.controls['creditCard'].errors && (form.controls['creditCard'].dirty || form.controls['creditCard'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">Expira*</ion-label>
              <ion-input
                id="cc-exp-date"
                formControlName="expirationDate"
                placeholder="12/26"
                type="tel"
                autocomplete="cc-exp"
                ccExp
              ></ion-input>
            </ion-item>
            <p
              *ngIf="form.controls['expirationDate'].errors && (form.controls['expirationDate'].dirty || form.controls['expirationDate'].touched)"
              class="danger ion-padding"
            >
              Inválido.
            </p>
          </ion-col>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">CVC*</ion-label>
              <ion-input
                id="cc-cvc"
                formControlName="cvc"
                placeholder="123"
                type="tel"
                autocomplete="off"
                ccCVC
              ></ion-input>
            </ion-item>
            <p
              *ngIf="form.controls['cvc'].errors && (form.controls['cvc'].dirty || form.controls['cvc'].touched)"
              class="danger ion-padding"
            >
              Inválido.
            </p>
          </ion-col>
        </ion-row>
      </ion-card-content>
    </ion-card>
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>Datos de facturación</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-item>
          <ion-label position="stacked">Teléfono*</ion-label>
          <ion-input type="tel" formControlName="phone"></ion-input>
        </ion-item>
        <p
          *ngIf="form.controls['phone'].errors && (form.controls['phone'].dirty || form.controls['phone'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">Calle y número*</ion-label>
          <ion-input type="text" formControlName="street"></ion-input>
        </ion-item>
        <p
          *ngIf="form.controls['street'].errors && (form.controls['street'].dirty || form.controls['street'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">Ciudad*</ion-label>
          <ion-input type="text" formControlName="city"></ion-input>
        </ion-item>
        <p
          *ngIf="form.controls['city'].errors && (form.controls['city'].dirty || form.controls['city'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">Estado*</ion-label>
          <ion-select name="state" formControlName="state">
            <ion-select-option value="Aguascalientes" selected>Aguascalientes</ion-select-option>
            <ion-select-option value="Baja California">Baja California</ion-select-option>
            <ion-select-option value="Baja California Sur">Baja California Sur</ion-select-option>
            <ion-select-option value="Campeche">Campeche</ion-select-option>
            <ion-select-option value="Chiapas">Chiapas</ion-select-option>
            <ion-select-option value="Chihuahua">Chihuahua</ion-select-option>
            <ion-select-option value="Coahuila">Coahuila</ion-select-option>
            <ion-select-option value="Colima">Colima</ion-select-option>
            <ion-select-option value="Distrito Federal">Distrito Federal</ion-select-option>
            <ion-select-option value="Durango">Durango</ion-select-option>
            <ion-select-option value="Estado de México">Estado de México</ion-select-option>
            <ion-select-option value="Guanajuato">Guanajuato</ion-select-option>
            <ion-select-option value="Guerrero">Guerrero</ion-select-option>
            <ion-select-option value="Hidalgo">Hidalgo</ion-select-option>
            <ion-select-option value="Jalisco">Jalisco</ion-select-option>
            <ion-select-option value="Michoacán">Michoacán</ion-select-option>
            <ion-select-option value="Morelos">Morelos</ion-select-option>
            <ion-select-option value="Nayarit">Nayarit</ion-select-option>
            <ion-select-option value="Nuevo León">Nuevo León</ion-select-option>
            <ion-select-option value="Oaxaca">Oaxaca</ion-select-option>
            <ion-select-option value="Puebla">Puebla</ion-select-option>
            <ion-select-option value="Querétaro">Querétaro</ion-select-option>
            <ion-select-option value="Quintana Roo">Quintana Roo</ion-select-option>
            <ion-select-option value="San Luis Potosí">San Luis Potosí</ion-select-option>
            <ion-select-option value="Sinaloa">Sinaloa</ion-select-option>
            <ion-select-option value="Sonora">Sonora</ion-select-option>
            <ion-select-option value="Tabasco">Tabasco</ion-select-option>
            <ion-select-option value="Tamaulipas">Tamaulipas</ion-select-option>
            <ion-select-option value="Tlaxcala">Tlaxcala</ion-select-option>
            <ion-select-option value="Veracruz">Veracruz</ion-select-option>
            <ion-select-option value="Yucatán">Yucatán</ion-select-option>
            <ion-select-option value="Zacatecas">Zacatecas</ion-select-option>
          </ion-select>
        </ion-item>
        <p
          *ngIf="form.controls['state'].errors && (form.controls['state'].dirty || form.controls['state'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">Código postal*</ion-label>
          <ion-input type="text" formControlName="zip"></ion-input>
        </ion-item>
        <p
          *ngIf="form.controls['zip'].errors && (form.controls['zip'].dirty || form.controls['zip'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">País</ion-label>
          <ion-select name="state" formControlName="country">
            <ion-select-option value="México" selected>México</ion-select-option>
          </ion-select>
        </ion-item>
        <p
          *ngIf="form.controls['country'].errors && (form.controls['country'].dirty || form.controls['country'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
      </ion-card-content>
    </ion-card>
    <ion-card>
      <ion-card-content>
        <ion-item>
          <ion-label>Guardar en dispositivo</ion-label>
          <span class="checkbox-container">
            <ion-checkbox formControlName="save"></ion-checkbox>
          </span>
        </ion-item>
      </ion-card-content>
    </ion-card>
    <p class="note">
      Los datos ingresados no serán guardados, serán tratados únicamente por el procesador de pagos o entidad bancaria
      correspondiente para esta transacción. Si ha seleccionado guardar, estos datos seran encriptados y guardados única
      y exclusivamente en este dispositivo.
    </p>
    <div>
      <ion-button shape="round" type="submit" [disabled]="form.invalid || !conektaKey" expand="block">Pagar</ion-button>
    </div>
  </form>
</ion-content>
